/// <reference types="@angular/localize" />

import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AuthCoreModule } from '@ortho-next/auth-core';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { getAuthConfig } from './app/auth.config';
import { APP_CONFIGURATION_TOKEN, AppConfiguration } from './app/core';


fetch('./config.json')
	.then((response: Response) => {
		if (response.ok) {
			return response.json();
		} else {
			return Promise.reject(new Error('Config file loading error...'));
		}
	}).then((config: AppConfiguration) => {
		bootstrapApplication(AppComponent, {
			providers: [
				{ provide: APP_CONFIGURATION_TOKEN, useValue: config },
				importProvidersFrom(AuthCoreModule.forRoot(getAuthConfig(config))),
				...appConfig.providers
			],
		}).catch((err) => console.error(err));
	}).catch((err) => console.error(err));
